import * as React from 'react';
import { Theme } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router';
import { JobButton } from 'components/Jobs/Buttons/JobButton';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { Counter, TextV2 } from '@insights-ltd/design-library/components';

interface IPropsType {
  editable: boolean;
  editStringsUri: string;
  totalStrings: number;
  onClickRemove: () => void;
}

const StringControl = ({
  editable,
  editStringsUri,
  totalStrings,
  onClickRemove,
}: IPropsType) => {
  const navigate = useNavigate();
  const onClickAdd = () => navigate(editStringsUri);

  return (
    <Grid
      container
      spacing={2}
      sx={(theme: Theme) => ({
        alignItems: 'center',
        paddingRight: theme.spacing(spacingSizeMap.XS),
        minHeight: '64px',
      })}
    >
      <Grid>
        <TextV2 variant="h3">
          Strings in job
          <Counter
            count={totalStrings}
            size="large"
            sx={{
              marginLeft: 1,
            }}
            counterAriaLabel="Label entries count"
          />
        </TextV2>
      </Grid>
      <Grid
        sx={{
          marginLeft: 'auto',
        }}
      >
        {totalStrings > 0 && editable && (
          <JobButton
            variant="outlined"
            onClick={onClickRemove}
            sx={(theme) => ({
              color: theme.palette.error.main,
              borderColor: theme.palette.error.main,
              border: '1px solid',
              backgroundColor: 'transparent',
              '&:hover': {
                borderColor: theme.palette.error.main,
                backgroundColor: `${theme.palette.error.main}16`,
              },
            })}
          >
            Remove strings
          </JobButton>
        )}
      </Grid>
      <Grid>
        {editable && (
          <JobButton variant="contained" color="primary" onClick={onClickAdd}>
            Add strings
          </JobButton>
        )}
      </Grid>
    </Grid>
  );
};

export default StringControl;
